export const login = [
  { label: "Phone number", value: 1 },
  // COMMENTED AS PER CLIENT REQUEST ON MARCH 7 2026
  // { label: "Email ID", value: 0 },
];
